import { rankingItems } from '@/mocks/homepage';

export default function RankingSection() {
  return (
    <section id="ranking" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热播榜单</h2>
          <p className="text-sm text-foreground-600">本周最受春夜观众喜爱的影片排行</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col gap-2">
            {rankingItems.map((item) => (
              <div
                key={item.id}
                className="flex items-center gap-4 p-4 rounded-xl bg-background-100 transition-all duration-300"
              >
                <div className={`w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0 ${
                  item.rank === 1 ? "bg-primary-500 text-background-50 dark:text-foreground-950" :
                  item.rank === 2 ? "bg-primary-400 text-background-50 dark:text-foreground-950" :
                  item.rank === 3 ? "bg-secondary-500 text-background-50 dark:text-foreground-950" :
                  "bg-background-200 text-foreground-600"
                }`}>
                  <span className="text-sm font-heading">{item.rank}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm md:text-base font-heading text-foreground-950">{item.title}</h3>
                    <span className="text-xs text-primary-500 font-medium whitespace-nowrap">{item.score} 分</span>
                  </div>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.tag}</p>
                </div>
                <div className="flex-shrink-0">
                  <span className={`w-6 h-6 flex items-center justify-center ${
                    item.trend === "up" ? "text-accent-500" :
                    item.trend === "down" ? "text-foreground-400" :
                    "text-secondary-500"
                  }`}>
                    <i className={`text-sm ${
                      item.trend === "up" ? "ri-arrow-up-line" :
                      item.trend === "down" ? "ri-arrow-down-line" :
                      "ri-subtract-line"
                    }`}></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}